export const mockPublicFeedCards = [
  {
    id: 'pub-1',
    kind: 'campaign',
    campaignType: 'FUND_COLLECT',
    authorName: 'Quartier Yopougon',
    authorInitials: 'QY',
    authorColor: 'green',
    tag: 'Cagnotte publique',
    tagColor: 'green',
    title: 'Fonds d\'urgence santé — quartier Yopougon',
    description: 'Financement des frais médicaux.',
    progress: { current: 60, total: 100, label: '60% collectés' },
    raised: 1200000,
    goal: 2000000,
    currency: 'FCFA',
    contributors: 34,
    deadlineLabel: '31 octobre 2026',
    extra: null,
    route: null,
  },
  {
    id: 'pub-2',
    kind: 'sponsored',
    sponsorName: 'PharmaCIV',
    sponsorLabel: 'Sponsorisé',
    title: 'PharmaCIV — mutuelle santé groupe',
    description: 'Rejoignez une mutuelle santé communautaire à partir de 2 000 CFA/mois.',
    sponsorColor: 'gold',
    route: null,
  },
  {
    id: 'pub-3',
    kind: 'campaign',
    campaignType: 'TICKETING',
    authorName: 'Festival Culturel Abidjan',
    authorInitials: 'FC',
    authorColor: 'purple',
    tag: 'Événement public',
    tagColor: 'purple',
    title: 'Festival Culturel Abidjan — RSVP ouvert',
    metaLine: '12 septembre · Abidjan',
    description: '180 participants inscrits. Entrée gratuite.',
    progress: { current: 180, total: 300, label: '180/300 RSVP' },
    extra: null,
    route: null,
  },
]